export function referrerOptionGridRowCount(optionCount, columns = 2) {
  if (optionCount <= 0) {
    return 1;
  }
  return Math.ceil(optionCount / columns);
}

/**
 * Equal height per row for a 2-column referrer grid, given the vertical space
 * available for all rows (gaps between rows are subtracted first).
 */
export function referrerOptionButtonHeightForRows({
  gridContentHeightPx,
  rowCount,
  rowGapPx = 10,
  minHeightPx = 72,
  maxHeightPx = 180,
}) {
  if (rowCount < 1) {
    return minHeightPx;
  }
  const gapTotal = Math.max(0, rowCount - 1) * rowGapPx;
  const raw = (gridContentHeightPx - gapTotal) / rowCount;
  return Math.min(maxHeightPx, Math.max(minHeightPx, Math.floor(raw)));
}

export function referrerOptionButtonHeightForOptions({
  gridContentHeightPx,
  optionCount,
  columns = 2,
  rowGapPx = 10,
  minHeightPx = 72,
  maxHeightPx = 180,
}) {
  const rows = referrerOptionGridRowCount(optionCount, columns);
  return referrerOptionButtonHeightForRows({
    gridContentHeightPx,
    rowCount: rows,
    rowGapPx,
    minHeightPx,
    maxHeightPx,
  });
}
